import React from 'react';
import PropTypes from 'prop-types';

const Card = ({ badge, bestPortal, imageUrl, alias, title, owner }) => (
  <div className="views-row">
    <div className="image-block">
      <div className="image">
        <a href={alias}>
          <img src={imageUrl} width="285" height="176" typeof="Image" className="img-responsive" />
        </a>
      </div>
    </div>
    <div className="site-informations">
      {badge === '' ? (
        <></>
      ) : (
        <div className="category-badge">
          <img src={badge} width="80" height="60" />
        </div>
      )}
      <h3 className="category-name">{bestPortal}</h3>
      <div className="site-name">
        <a href={alias}>{title}</a>
      </div>
      <div className="information-block">
        <div className="information">by {owner}</div>
      </div>
    </div>
  </div>
);

Card.defaultProps = {
  badge: '',
  bestPortal: '',
  imageUrl: '',
  alias: '',
  title: '',
  owner: '',
}

Card.propTypes = {
  badge: PropTypes.string,
  bestPortal: PropTypes.string,
  imageUrl: PropTypes.string,
  alias: PropTypes.string,
  title: PropTypes.string,
  owner: PropTypes.string,
}

export default Card;
